import React from "react";

export const dataSummary = {
  "id": "475e89f7-bf05-4be5-b152-fb3915db2fa7",
  "name": "Mariscal Salas Paola",
  "completed": true,
  "entities": [
    {
      "name": "Planes de Acción",
      "id": "3bc26b41-8870-432b-af4c-7ea66af6993b",
      "states": [
        {
          "id": "PR",
          "state": "Proceso",
          "quantity": 3
        },
        {
          "id": "RA",
          "state": "Revisión de auditoría",
          "quantity": 10
        },
        {
          "id": "RP",
          "state": "Reprogramados",
          "quantity": 23
        },
        {
          "id": "CU",
          "state": "Culminados",
          "quantity": 45
        },
        {
          "id": "CE",
          "state": "Cambio de estructura",
          "quantity": 8
        },
        {
          "id": "VE",
          "state": "Vencidos",
          "quantity": 14
        }
      ],
      "notifications": [
        {
          "id": 1,
          "text": "Planes próximos a vencer",
          "quantity": 34
        },
        {
          "id": 2,
          "text": "Sin avances ",
          "quantity": 13
        },
        {
          "id": 3,
          "text": "Sin avances y próximos a vencer",
          "quantity": 21
        }
      ]
    },
    {
      "name": "Riesgos",
      "id": "3c643df7-635d-459b-9556-e160fe1b706f",
      "severity": [
        {
          "id": 1,
          "level": "Catastrófico",
          "color": "#FF0000",
          "quantity": 10
        },
        {
          "id": 2,
          "level": "Alto",
          "color": "#FF6600",
          "quantity": 12
        },
        {
          "id": 3,
          "level": "Moderado",
          "color": "#FFFF00",
          "quantity": 41
        },
        {
          "id": 4,
          "level": "Bajo",
          "color": "#99CC00",
          "quantity": 13
        },
        {
          "id": 5,
          "level": "Muy Bajo",
          "color": "#339966",
          "quantity": 13
        }
      ],
      "notifications": [
        {
          "id": 1,
          "text": "riesgos con tratamiento a mitigar sin planes vinculados ",
          "quantity": 31
        },
        {
          "id": 2,
          "text": "riesgos con tratamiento a mitigar sin monitoreo mediante indicadores",
          "quantity": 18
        },
        {
          "id": 3,
          "text": "riesgos con pérdidas vinculadas superioresal nivel de riesgo",
          "quantity": 7
        }
      ]
    },
    {
      "name": "Indicadores",
      "id": "ad8406d1-3c9e-48d7-bf31-41e5cdb8fef1",
      "scales": [
        {
          "id": 2,
          "name": "Alto",
          "color": "#FF0000",
          "quantity": 31,
        },
        {
          "id": 3,
          "name": "Medio",
          "color": "#FFFF00",
          "quantity": 48
        },
        {
          "id": 4,
          "name": "Bajo",
          "color": "#008000",
          "quantity": 29
        }
      ],
      "notifications": [
        {
          "id": 1,
          "text": "Indicadores cercanos a reportar",
          "quantity": 5
        },
        {
          "id": 2,
          "text": "Indicadores que se reporaron fuera de fecha.",
          "quantity": 12
        },
        {
          "id": 3,
          "text": "Indicadores que no se reportaron",
          "quantity": 14
        }
      ]
    }
  ]
}

export const menuRO = [
  {
    id: "2",
    title: "Seleccione un modulo",
    subtitle: "-",
    route: "",
    separator: true,
    children: [
      {
        id: "IN",
        title: "Mis Incidentes",
        subtitle: "Administra tus incidentes",
        route: "incidents",
      },
      {
        id: "EV",
        title: "Mis eventos",
        subtitle: "Administra las perdidas",
        route: "events",
      },
      {
        id: "RI",
        title: "Mis riesgos",
        subtitle: "Administra tus riesgos",
        route: "risks",
      },
      {
        id: "PL",
        title: "Mis planes",
        subtitle: "Administra tus planes",
        route: "plans",
      },
      {
        id: "ID",
        title: "Mis indicadores",
        subtitle: "Administra tus indicadores",
        route: "indicators",
      }
    ]
  },
  {
    id: "1",
    title: "Dashboard",
    subtitle: "Resumen e historial",
    route: "dashboard",
    separator: true
  },
  {
    id: "3",
    title: "Documentos",
    subtitle: "Administra tus documentos",
    route: "documents",
    separator: true
  },
  {
    id: "4",
    title: "Reportes",
    subtitle: "Consulta y crea tus reportes",
    route: "reports",
    separator: true
  },
  {
    id: "5",
    title: "Configuración",
    subtitle: "Adapta GIRO a tu necesidad",
    route: "settings",
    separator: false
  }
];

export const menuSI = [
  {
    id: "1",
    title: "Dashboard",
    subtitle: "Resumen e historial",
    route: "dashboard",
    separator: true
  },
  {
    id: "2",
    title: "Seleccione un modulo",
    subtitle: "-",
    route: "",
    separator: true,
    children: [
      {
        id: "AC",
        title: "Mis activos",
        subtitle: "Administra los activos",
        route: "events",
      },
      {
        id: "RI",
        title: "Mis riesgos",
        subtitle: "Administra tus riesgos",
        route: "risks",
      },
      {
        id: "PL",
        title: "Mis planes",
        subtitle: "Administra tus planes",
        route: "plans",
      },
      {
        id: "ID",
        title: "Mis indicadores",
        subtitle: "Administra tus indicadores",
        route: "indicators",
      }
    ]
  },
  {
    id: "3",
    title: "Documentos",
    subtitle: "Administra tus documentos",
    route: "documents",
    separator: true
  },
  {
    id: "4",
    title: "Reportes",
    subtitle: "Consulta y crea tus reportes",
    route: "reports",
    separator: true
  },
  {
    id: "5",
    title: "Configuración",
    subtitle: "Adapta GIRO a tu necesidad",
    route: "settings",
    separator: false
  }
];

export const quickOptions = [
  {id: 1, name: 'Today'},
  {id: 2, name: 'Yesterday'},
  {id: 3, name: 'Last week'},
  {id: 4, name: 'Last month'}
];

export const modules = [
  {
    id: 1,
    name: 'Incidents',
    translationKey: 'incidents',
    alternative: 'Incidents',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316448H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316448Z" fill="#F44336"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#D32F2F"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">IN</text>
    </svg>
  },
  {
    id: 2,
    name: 'Assets',
    translationKey: 'assets',
    alternative: 'Assets',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316448H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316448Z" fill="#258BF6"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#0C72E5"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">AS</text>
    </svg>
  },
  {
    id: 3,
    name: 'Action Plans',
    translationKey: 'actionPlans',
    alternative: 'Plans',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z" fill="#77A23F"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#5C8130"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">AP</text>
    </svg>
  },
  {
    id: 4,
    name: 'Risks',
    translationKey: 'risks',
    alternative: 'Risks',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z" fill="#FF9800"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#E68900"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">RI</text>
    </svg>
  },
  {
    id: 5,
    name: 'Indicators',
    translationKey: 'indicators',
    alternative: 'Indicators',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z" fill="#9B59B6"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#7D3C98"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">ID</text>
    </svg>
  },
  {
    id: 6,
    name: 'Suppliers',
    translationKey: 'suppliers',
    alternative: 'Suppliers',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z" fill="#1ABC9C"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#16A085"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">PR</text>
    </svg>
  },
  {
    id: 7,
    name: 'Loss Events',
    translationKey: 'lossEvents',
    alternative: 'Events',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z" fill="#FF6F00"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#E65100"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">EV</text>
    </svg>
  },
  {
    id: 8,
    name: 'BIA',
    translationKey: 'bia',
    alternative: 'BIA',
    icon: <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z" fill="#FFBC0F"/>
      <path d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z" fill="#B68710"/>
      <text x="13" y="24" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">BI</text>
    </svg>
  },
  {
    id: 9,
    name: 'Audit',
    translationKey: 'audit',
    alternative: 'Audit',
    icon: <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.24936L14.3223 24.6897H13.2783L8.76196 20.7809H0V2.24936Z" fill="#F7941D"/>
      <path d="M7.3819 6.54988L2.64276 0H24.67V24.6853H17.5634V6.55868L7.3819 6.54988Z" fill="#F7941D"/>
    </svg>
  }
];

export const iconProduct = <svg width="24" height="24" viewBox="0 0 16 16" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1.99999 1.33325H6.66666C7.06666 1.33325 7.33333 1.59992 7.33333 1.99992V6.66659C7.33333 7.06659 7.06666 7.33325 6.66666 7.33325H1.99999C1.59999 7.33325 1.33333 7.06659 1.33333 6.66659V1.99992C1.33333 1.59992 1.59999 1.33325 1.99999 1.33325Z"/>
  <path opacity="0.3"
        d="M9.33334 1.33325H14C14.4 1.33325 14.6667 1.59992 14.6667 1.99992V6.66659C14.6667 7.06659 14.4 7.33325 14 7.33325H9.33334C8.93334 7.33325 8.66667 7.06659 8.66667 6.66659V1.99992C8.66667 1.59992 8.93334 1.33325 9.33334 1.33325Z"/>
  <path opacity="0.3"
        d="M1.99999 8.66675H6.66666C7.06666 8.66675 7.33333 8.93341 7.33333 9.33341V14.0001C7.33333 14.4001 7.06666 14.6667 6.66666 14.6667H1.99999C1.59999 14.6667 1.33333 14.4001 1.33333 14.0001V9.33341C1.33333 8.93341 1.59999 8.66675 1.99999 8.66675Z"/>
  <path opacity="0.3"
        d="M9.33334 8.66675H14C14.4 8.66675 14.6667 8.93341 14.6667 9.33341V14.0001C14.6667 14.4001 14.4 14.6667 14 14.6667H9.33334C8.93334 14.6667 8.66667 14.4001 8.66667 14.0001V9.33341C8.66667 8.93341 8.93334 8.66675 9.33334 8.66675Z"/>
</svg>;

export const userMenuItems = [
  {
    key: 'profile',
    translationKey: 'profile',
    icon: 'UserOutlined',
    route: '/profile'
  },
  {
    key: 'settings',
    translationKey: 'settings',
    icon: 'SettingOutlined',
    route: '/settings'
  },
  {
    key: 'password',
    translationKey: 'password',
    icon: 'LockOutlined',
    route: '/change-password'
  },
  {
    key: 'notifications',
    translationKey: 'notifications',
    icon: 'BellOutlined',
    route: '/notifications'
  },
  {
    key: 'activityLog',
    translationKey: 'activityLog',
    icon: 'HistoryOutlined',
    route: '/activity-log'
  },
  {
    key: 'divider',
    type: 'divider'
  },
  {
    key: 'help',
    translationKey: 'help',
    icon: 'QuestionCircleOutlined',
    route: '/help'
  },
  {
    key: 'divider2',
    type: 'divider'
  },
  {
    key: 'logout',
    translationKey: 'logout',
    icon: 'LogoutOutlined',
    route: '/logout',
    danger: true
  }
];
